function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21801"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1919",
    d: "M24 24H0V0h24z",
    transform: "rotate(-90 12 12)",
    style: {
      opacity: 0.87,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17703",
    d: "M13.6 16.2 8 10.6 13.6 5",
    transform: "rotate(180 11.25 11.25)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgRight;